import React from 'react'
import axios from 'axios'
import {
  Alert,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  FormText,
  Container,
  Row,
  Col,
  CustomInput
} from 'reactstrap'
import {connect} from 'react-redux'
import MyEditor from './Draft.js'
import MyEditorSynthesis from './Draft_Synthesis.js'
import moment from 'moment'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'

function tradError (x) {
  if (x === 201) { return 'Votre article a été crée avec succés!' }
  if (x === 409) { return 'Ce titre est déjà utilisé.' }
  if (x === 503) { return 'Erreur' }
  if (x === 400) { return 'Verifiez bien que tous les champs on bien été remplis...' }
}

function sendchallenge (x, challenge) {
  axios({
    method: 'POST',
    url: `${process.env.REACT_APP_API_URL}/content/challenge/`,
    data: challenge,
    headers: {
      'Content-Type': 'multipart/form-data',
      'Authorization': 'Bearer ' + sessionStorage.getItem('token')
    }
  }).then((res) => {
    x.setState({
      ...x.state,
      challenge: {
        ...x.state.challenge,
        endDate: x.state.challenge.endDate._d
      },
      resCode: res.request.status,
      resMsg: tradError(res.request.status)
    })
  }).catch((res, err) => {
    x.setState({
      ...x.state,
      resCode: res.request.status,
      resMsg: tradError(res.request.status)
    })
  })
}

class CreateChallenge extends React.Component {
  constructor () {
    super()
    this.state = {
      challenge: {
        title: '',
        image: null,
        embedded: null,
        description: '',
        content: '',
        categories: [],
        endDate: undefined,
        synthesis: ''
      },
      categories: [],
      imgPrev: '',
      resCode: null,
      isSubmitted: undefined,
      dateSelect: moment()
    }
    this.handleClick = this.handleClick.bind(this)
    this.handleImage = this.handleImage.bind(this)
    this.handleCategories = this.handleCategories.bind(this)
    this.handleText = this.handleText.bind(this)
  }

  componentWillMount () {
    this.setState({
      ...this.state,
      categories: this.props.categories
    })
  }

  componentDidUpdate () {
    if (this.state.challenge.content !== this.props.challengeHTML) {
      this.setState({
        ...this.state,
        challenge: {
          ...this.state.challenge,
          synthesis: this.props.synthesisHTML,
          content: this.props.challengeHTML
        }
      })
    }
    if (this.state.challenge.synthesis !== this.props.synthesisHTML) {
      this.setState({
        ...this.state,
        challenge: {
          ...this.state.challenge,
          synthesis: this.props.synthesisHTML
        }
      })
    }
  }

  handleDate (date) {
    this.setState({
      ...this.state,
      dateSelect: date,
      challenge: {
        ...this.state.challenge,
        endDate: new Date(date)
      }
    })
  }

  handleClick () {
    const formData = new FormData()
    let challenge = this.state.challenge
    for (let key in challenge) {
      formData.append(key, challenge[key])
    }
    sendchallenge(this, formData)
    this.setState({
      isSubmitted: true
    })
    console.log(this.state)
  }

  handleText (e) {
    this.setState({
      ...this.state,
      challenge: {
        ...this.state.challenge,
        [e.target.name]: e.target.value
      }
    })
  }

  handleCategories (e) {
    let cat = this.state.challenge.categories.concat(e.target.id)
    this.setState({
      ...this.state,
      challenge: {
        ...this.state.challenge,
        categories: cat
      }
    })
  }

  handleImage (e) {
    e.preventDefault()
    let reader = new FileReader()
    let file = e.target.files[0]

    reader.onload = () => {
      this.setState({
        ...this.state,
        imgPrev: reader.result,
        challenge: {
          ...this.state.challenge,
          image: file
        }
      })
    }
    reader.readAsDataURL(file)
  }

  render () {
    let itit = this.state.categories.filter(cat => cat.type === 'BOARD')
    let time = this.state.categories.filter(cat => cat.type === 'TIME')
    let global = this.state.categories.filter(cat => cat.type === 'GLOBAL')
    const DATE = this.state.challenge.endDate !== undefined ? 'La date limite de participation au challenge sera le ' + this.state.challenge.endDate.toLocaleDateString() : ''
    return (<div>
      <Container className={'mT-5 mB-5'}>
        <Row>
          <Col>
            <h1 className={'txtcenter'}>Créer un challenge</h1>
          </Col>
        </Row>
        <hr />
        <Form>
          <Row>
            <Col md={{
              size: 6,
              offset: 3
            }}>
              <FormGroup>
                <Label className={'font-b'} for='exampleText'>Titre <span className={'color-red'}>*</span></Label>
                <Input type='text' name='title' id='title' onChange={this.handleText.bind(this)} />
              </FormGroup>
              <FormGroup>
                <Label className={'font-b'}  for='exampleText'>Description Courte <span className={'color-red'}>*</span></Label>
                <Input type='textarea' name='description' id='shortDescription' onChange={this.handleText.bind(this)} />
              </FormGroup>
              <FormGroup>
                <Label className={'font-b'}  for='exampleText'>Code Embed <span className={'color-red'}>*</span></Label>
                <Input type='url' placeholder='<iframe ... >...</iframe>' name='embedded' id='embedded' onChange={this.handleText.bind(this)} />
                <p className={'txtcenter pT-2'}>Exemple:</p>
                <ul>
                  <li>Texte:  <span className={'color-green'}>{'  <p>Votre texte ici</p>'}</span></li>
                  <li>Vidéo (Youtube ou Vimeo): <span className={'color-green'}>{'<iframe...>...</iframe...>'}</span></li>
                  <li>Image: <span className={'color-green'}>{'<img src=\'monURL\' alt=\'monTitre\'>'}</span></li>
                </ul>
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col md={{ size: 6, offset: 3 }}>
              <Label className={'font-b'}  for='exampleFile'>Image: <span className={'color-red'}>*</span></Label>
              <Input type='file' name='file' onChange={this.handleImage.bind(this)} />
              <FormText color='muted'>
                Taille maximale: 5mb
              </FormText>
              <div className={'txtcenter '}>
                {
                  this.state.imgPrev === ''
                    ? null
                    : <img className={'imgResponsive'} src={this.state.imgPrev} alt='preview' />
                }
              </div>
            </Col>
          </Row>
          <Row className={''}>
            <Col sm={{ size: 6, offset: 3 }} className={''}>
              <Label>Date Limite: <span className={'color-red'}>*</span></Label>
              <Col className={'txtcenter'}>
                <DatePicker format='DD-MM-YYYY' inline selected={this.state.dateSelect} onChange={this.handleDate.bind(this)} locale='fr' />
              </Col>
            </Col>
          </Row>
          <Row className={''}>
            <Col sm={{ size: 6, offset: 3 }} className={'vCenter txtcenter roboto grey-ititoca mR-15'}>
              <h4>{DATE}</h4>
            </Col>
          </Row>
          <Row>
            <Col>
              <h3>Catégories: <span className={'color-red'}>*</span></h3>
            </Col>
          </Row>
          <hr />
          <Row className={''}>
            <Col className={''}>
              <FormGroup className={'hCenter'}>
                <Label className={'font-b marker'} for='exampleCheckbox'>ITITOCA Board</Label>
                <div>
                  {
                    itit.map(cat => {
                      return (<CustomInput name={cat.name} type='checkbox' id={cat._id} key={cat._id} value={cat.name} inline={true} onClick={this.handleCategories.bind(this)}>{cat.name}</CustomInput>)
                    })
                  }
                </div>
              </FormGroup>
            </Col>
            <Col className={'vCenter'}>
              <FormGroup>
                <Label className={'font-b marker'} for='exampleCheckbox'>Temps</Label>
                <div>
                  {time.map(cat => <CustomInput name={cat.name} type='checkbox' id={cat._id} key={cat._id} value='10mins' inline={true} onClick={this.handleCategories.bind(this)}>{cat.name}</CustomInput>)}
                </div>
              </FormGroup>
            </Col>
            <Col className={'vCenter'}>
              <FormGroup>
                <Label className={'font-b marker'} for='exampleCheckbox'>Cible</Label>
                <div>
                  {global.map(cat => <CustomInput name={cat.name} type='checkbox' id={cat._id} key={cat._id} value='Moi' inline={true} onClick={this.handleCategories.bind(this)}>{cat.name}</CustomInput>)}
                </div>
              </FormGroup>
            </Col>
          </Row>
          <hr />
          <Row>
            <Col>
              <h4 className={'vCenter'}>Tapez ici le corps du Challenge <span className={'color-red'}>*</span></h4>
              <MyEditor />
            </Col>
          </Row>
          <Row>
            <Col className={'mT-3'}>
              <h4 className={'vCenter'}>Tapez ici la synthèse du Challenge</h4>
              <MyEditorSynthesis />
            </Col>
          </Row>
        </Form>
        <hr />
        <Row>
          <Col>
                  {
                    this.state.resCode !== null ? <Alert color={this.state.resCode === 201? 'success' : 'danger'}><i className={this.state.resCode === 201 ? 'check icon' : 'exclamation circle icon'}></i>{this.state.resMsg}</Alert> : null
                  }
          </Col>
          <Col className={'txtright'}>
            <Button className={'w30p pT-4 pB-10'} color='success' onClick={this.handleClick.bind(this)}>POSTER</Button>
          </Col>
        </Row>
      </Container>
    </div>)
  }
}

function mapStateToProps (state) {
  return {categories: state.data.categories, challengeHTML: state.content.htmlContent, synthesisHTML: state.synthesis.htmlSynthesis}
}

export default connect(mapStateToProps, null)(CreateChallenge)

export {
  CreateChallenge
}



// WEBPACK FOOTER //
// ./src/components/CreateChallenge.js